/** ArcLog OS module SDK — TypeScript is the app language. Multi-version capable. */
export const ARCLOG_API_VERSION = 1;
/**
 * The OS version. **This constant is the only place it is written down.**
 *
 * It sat at "0.2.0" through roughly fifty commits — `ctx.agents`, `ctx.db`,
 * KeyChain, Trading 0.5 → 0.9.7, the visual refresh — because nothing in the
 * build asserts that shipping SDK surface bumps it. Four other places had
 * typed the string out by hand and drifted with it. They now read this
 * constant. If you add SDK surface, bump this and follow
 * `docs/sdk/27-releases.md`: a version nobody bumps is a version nobody can
 * ask "which build am I running?" about.
 */
export const ARCLOG_OS_VERSION = "0.3.0";
/** Well-known permission strings */
export const Perms = {
    PACKAGES_INSTALL: "os.packages.install",
    PACKAGES_UNINSTALL: "os.packages.uninstall",
    PACKAGES_CHANNEL_STABLE: "os.packages.channel.stable",
    PACKAGES_CHANNEL_BETA: "os.packages.channel.beta",
    PACKAGES_CHANNEL_DEV: "os.packages.channel.dev",
    PACKAGES_CHANNEL_CANARY: "os.packages.channel.canary",
    PACKAGES_RUN_ANY_VERSION: "os.packages.run.any",
    HERMES_CHAT: "hermes.chat",
    ADMIN: "os.admin",
    // In-OS app authoring (Hermes builds apps with you through Terminal)
    APPDEV_SCAFFOLD: "os.appdev.scaffold",
    APPDEV_WRITE: "os.appdev.write",
    APPDEV_BUILD: "os.appdev.build",
    APPDEV_PUBLISH: "os.appdev.publish",
    // Full-OS upgrade path (opt-in only — never auto-apply)
    UPDATE_CHECK: "os.update.check",
    UPDATE_DOWNLOAD: "os.update.download",
    UPDATE_APPLY: "os.update.apply",
    UPDATE_SNAPSHOT: "os.update.snapshot",
    UPDATE_ROLLBACK: "os.update.rollback",
    // Multi-user + VFS + OpenCode
    FS_READ: "os.fs.read",
    FS_WRITE: "os.fs.write",
    FS_WRITE_SHARED: "os.fs.write.shared",
    USERS_MANAGE: "os.users.manage",
    OPENCODE_RUN: "os.opencode.run",
    OPENCODE_UPDATE: "os.opencode.update",
    INSTALL_COMPLETE: "os.install.complete",
    /**
     * Outbound HTTPS GET through the OS proxy (`ctx.http`). This permission plus
     * the server's host allowlist ARE the trust boundary — a module manifest's
     * `net` declaration is consent UX, never enforcement.
     */
    NET_FETCH: "os.net.fetch",
    // Agents — shared per-account AI workers (jobs, messages, memory)
    AGENTS_RUN: "os.agents.run",
    AGENTS_MANAGE: "os.agents.manage",
};
//# sourceMappingURL=index.js.map